"use client";

import style from "./style.module.scss";
import {
  HEADER_MENU,
  GOOGLE_PLAY_URL,
  APP_STORE_URL,
  PATHNAMES_WITHOUT_HEADER,
} from "@/constants";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { useRouter } from "next/navigation";
import Image from "next/image";
import { useState } from "react";
import Markets from "../markets";
import { openExternalLink } from "@/helpers/security-helpers";

export const Header = () => {
  const pathname = usePathname();
  const router = useRouter();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [shouldRenderMobileMenu, setShouldRenderMobileMenu] = useState(false);
  const isHeaderHidden = PATHNAMES_WITHOUT_HEADER.some((p) =>
    pathname.includes(p)
  );

  const handleMobileMenuClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    e.stopPropagation();
    if (isMobileMenuOpen) {
      setIsMobileMenuOpen(false);
      return;
    }

    setShouldRenderMobileMenu(true);
    requestAnimationFrame(() => {
      setIsMobileMenuOpen(true);
    });
  };

  const handleLogoClick = () => {
    router.push("/");
  };

  const handleAppStoreClick = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    openExternalLink(APP_STORE_URL);
  };

  const handleGooglePlayClick = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    openExternalLink(GOOGLE_PLAY_URL);
  };

  const handleMobileNavigation = () => {
    setIsMobileMenuOpen(false);
  };

  return (
    !isHeaderHidden && (
      <>
        <header className={style.header}>
          <div className={style.logoContainer}>
            <Image
              className={style.logoImage}
              src="/icon/markets/aviation-logo.svg"
              alt="markets"
              width={0}
              height={32}
              onClick={handleLogoClick}
            />
            <div className={style.marketsWrapper}>
              <Markets height={40} />
            </div>
          </div>
          <div className={style.navContainer}>
            {HEADER_MENU.map((elem) => (
              <Link
                key={elem.path}
                href={elem.path}
                className={`${style.navItem} ${
                  pathname === elem.path ? style.navItemActive : ""
                }`}
              >
                {elem.title}
              </Link>
            ))}
          </div>
          <button
            className={style.mobileMenuButton}
            onClick={handleMobileMenuClick}
          >
            {isMobileMenuOpen ? (
              <Image src="/icon/Cancel.svg" alt="menu" width={32} height={32} />
            ) : (
              <Image src="/icon/Menu.svg" alt="menu" width={32} height={32} />
            )}
          </button>
        </header>
        {shouldRenderMobileMenu && (
          <div
            className={`${style.mobileMenu} ${
              isMobileMenuOpen ? style.mobileMenuOpen : ""
            }`}
            onTransitionEnd={(event) => {
              if (event.target === event.currentTarget && !isMobileMenuOpen) {
                setShouldRenderMobileMenu(false);
              }
            }}
          >
            <div className={style.navMobileMenu}>
              {HEADER_MENU.map((elem) => (
                <Link
                  key={elem.path}
                  href={elem.path}
                  className={`${style.navItem} ${
                    pathname === elem.path ? style.navItemActive : ""
                  }`}
                  onClick={handleMobileNavigation}
                >
                  {elem.title}
                </Link>
              ))}
            </div>
            <div className={style.marketsMobileMenu}>
              <Markets height={44} />
            </div>
          </div>
        )}
      </>
    )
  );
};
